import Http from '@/api/http.js'

export default {

  indexDevolutions(filters) {
    return Http.get(`/devolutions/pay_devolutions`, {params: {...filters}})
  },

  show(id) {
    return Http.get(`/devolutions/pay_devolutions/${id}`);
  },
  
  createItemDevolution(devolution){
    return Http.post(`/devolutions/item_devolutions`, {devolution: {...devolution}})
  },


}
